import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const AbandonedCartAutomationSetupPage = lazy(
  () => import("../../pages/AbandonedCartAutomationSetupPage")
);
const BrandFundedPromoModalExplorationPage = lazy(
  () => import("../../pages/BrandFundedPromoModalExplorationPage")
);

export function LaurenBlakeRoutes() {
  return (
    <Switch>
      <Route
        path="/lb/abandoned-cart-automation-setup"
        component={AbandonedCartAutomationSetupPage}
      />
      <Route
        path="/lb/brand-funded-promo-modal-exploration"
        component={BrandFundedPromoModalExplorationPage}
      />
    </Switch>
  );
}

export const slug = "lb";
